import { TransferRateType } from '@rd/types';
import { z } from 'zod';

export const transferRateTypeSchema = z.nativeEnum(TransferRateType);

const transferRateGenericModelSchema = z.object({
  denomination: z.number(),
  targetDenomination: z.number(),
  minimumTransfer: z.number(),
  maximumTransfer: z.number(),
  exchangeRate: z.number(),
  loyaltyCurrencyId: z.string(),
  targetMaximumTransfer: z.number(),
  targetMinimumTransfer: z.number(),
});

export const pointsTransferRateModelSchema = z.object({
  id: z.string(),
  type: z.literal(TransferRateType.Points),
  attributes: transferRateGenericModelSchema,
});

export const cashTransferRateModelSchema = z.object({
  id: z.string(),
  type: z.literal(TransferRateType.Cash),
  attributes: transferRateGenericModelSchema,
});
